export const getDayInEnglish = (day = '') => {
  if (day === 'شنبه') {
    return 'Saturday';
  } else if (day === 'یکشنبه') {
    return 'Sunday';
  } else if (day === 'دوشنبه') {
    return 'Monday';
  } else if (day === 'سه‌شنبه') {
    return 'Tuesday';
  } else if (day === 'چهارشنبه') {
    return 'Wednesday';
  } else if (day === 'پنجشنبه') {
    return 'Thursday';
  } else if (day === 'جمعه') {
    return 'Friday';
  }
};

export const getPackMonthNumFromTextMode = (duration) => {
  switch (duration) {
    case 'yearly':
      return 12;
    case 'triennial':
      return 36;
    case 'quarterly':
      return 3;
    case 'monthly':
      return 1;
    default:
      return 1;
  }
};
